/**
 * 구독 결제 내역 리스트
 * FSD: features/subscription/subscription-manage/ui
 */

import React from 'react';
import type { BillingTransaction } from '@/entities/subscription/model';
import { formatAmount, formatDate } from '@/shared/lib/payment/format-amount';
import { getStatusBadge, getStatusClass } from '@/shared/lib/payment/payment-status';

interface BillingHistoryListProps {
  history: BillingTransaction[];
}

export const BillingHistoryList: React.FC<BillingHistoryListProps> = ({ history }) => {
  return (
    <div className="billing-history-list">
      <table className="billing-table">
        <thead>
          <tr>
            <th>결제 날짜</th>
            <th>금액</th>
            <th>상태</th>
            <th>승인번호</th>
            <th>취소 내역</th>
          </tr>
        </thead>
        <tbody>
          {history.map((item) => (
            <tr key={item.id}>
              <td>{formatDate(item.approval_date || item.created_at)}</td>
              <td>{formatAmount(item.amount)}</td>
              <td>
                <span className={`badge ${getStatusClass(item.status)}`}>
                  {getStatusBadge(item.status)}
                </span>
              </td>
              <td>{item.approval_number || '-'}</td>
              <td>
                {item.cancellations && item.cancellations.length > 0 ? (
                  <ul className="cancellations-list">
                    {item.cancellations.map((cancel) => (
                      <li key={cancel.id}>
                        {formatAmount(cancel.cancel_amount)} ({cancel.cancel_msg})
                      </li>
                    ))}
                  </ul>
                ) : (
                  '-'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
